<div *ngIf="activeStepLogin > 0">
    <div class="login-wrapper outer" [ngClass]="{ show: activeStepLogin === 1 }">
        <h4 [innerHTML]="'login.title' | translate"></h4>
        <p *ngIf="hasLoginInfoSpecialAccess$ | async" class="info-note" [innerHTML]="'login.infoSpecialAccess' | translate"></p>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="login-wrapper">
                <div
                    class="form-group"
                    [class.active]="hasFocusUsername || hasValue(f.username)"
                    [class.hasvalue]="!hasFocusUsername && hasValue(f.username)"
                >
                    <label
                        for="username"
                        [class.active]="hasFocusUsername || hasValue(f.username)"
                        [class.hasvalue]="!hasFocusUsername && hasValue(f.username)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'login.username' | translate"></span></span>
                        <input
                            formControlName="username"
                            id="username"
                            (focus)="hasFocusUsername = true"
                            (blur)="hasFocusUsername = false"
                            type="text"
                        />
                    </label>
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required" [innerHTML]="'login.usernameRequired' | translate"></div>
                        <div *ngIf="f.username.errors.pattern" [innerHTML]="'login.emailFormat' | translate"></div>
                    </div>
                </div>
                <div
                    class="form-group"
                    [class.active]="hasFocusPassword || hasValue(f.password)"
                    [class.hasvalue]="!hasFocusPassword && hasValue(f.password)"
                >
                    <label
                        for="password"
                        [class.active]="hasFocusPassword || hasValue(f.password)"
                        [class.hasvalue]="!hasFocusPassword && hasValue(f.password)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'login.password' | translate"></span></span>
                        <input
                            formControlName="password"
                            id="password"
                            (focus)="hasFocusPassword = true"
                            (blur)="hasFocusPassword = false"
                            type="password"
                        />
                    </label>
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required" [innerHTML]="'login.passwordRequired' | translate"></div>
                    </div>
                </div>
            </div>

            <div class="form-group button-wrapper">
                <div class="forgot-password">
                    <a href="javascript:;" (click)="forgotPassword()" *ngIf="showForgotPassword$ | async" icon="drg-icon-arrow_right">
                        <span [innerHTML]="'login.forgotPassword' | translate"></span>
                    </a>
                </div>

                <div class="inner-wrapper">
                    <button [disabled]="loading" class="button primary">
                        <span [innerHTML]="'login.submit' | translate"></span>
                    </button>
                    <a href="javascript:;" class="cancel button secondary" (click)="cancel()">
                        <span [innerHTML]="'login.cancel' | translate"></span>
                    </a>
                </div>
            </div>
            <div *ngIf="showError$ | async" class="error-message" [innerHTML]="'login.error' | translate"></div>
        </form>
    </div>
    <ng-container *ngIf="activeStepLogin2$ | async as activeStepLogin2">
        <div [ngClass]="{ show: activeStepLogin2 === 2 }" class="forgot-password-wrapper outer">
            <h4 [innerHTML]="'forgotPassword.title' | translate"></h4>
            <p class="large" [innerHTML]="'forgotPassword.intro' | translate"></p>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgotPassword()">
                <div class="forgot-password-wrapper">
                    <div
                        class="form-group"
                        [class.active]="hasFocus || hasValue(f2.username2)"
                        [class.hasvalue]="!hasFocus && hasValue(f2.username2)"
                    >
                        <label
                            for="username2"
                            [class.active]="hasFocus || hasValue(f2.username2)"
                            [class.hasvalue]="!hasFocus && hasValue(f2.username2)"
                        >
                            <span class="labelcontent"><span [innerHTML]="'forgotPassword.username' | translate"></span></span>
                            <input
                                formControlName="username2"
                                id="username2"
                                (focus)="hasFocus = true"
                                (blur)="hasFocus = false"
                                type="text"
                            />
                        </label>
                        <div *ngIf="submitted && (f2.username2.errors || showMessage)" class="invalid-feedback">
                            <div
                                *ngIf="f2.username2.errors && f2.username2.errors.required"
                                [innerHTML]="'forgotPassword.usernameRequired' | translate"
                            ></div>
                            <div
                                *ngIf="f2.username2.errors && f2.username2.errors.pattern"
                                [innerHTML]="'forgotPassword.emailFormat' | translate"
                            ></div>
                        </div>
                    </div>
                    <div class="form-group button-wrapper">
                        <a href="javascript:;" class="secondary button" (click)="cancel()"
                            ><span [innerHTML]="'forgotPassword.cancel' | translate"></span
                        ></a>
                        <button [disabled]="loaded$ | async" class="button primary">
                            <span [innerHTML]="'forgotPassword.submit' | translate"></span>
                        </button>
                    </div>
                    <div *ngIf="showErrorMessageBackEnd$ | async" class="error-message">
                        <div [innerHTML]="'forgotPassword.errorMessage' | translate"></div>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-container *ngIf="activeStepLogin3$ | async as activeStepLogin3">
        <div class="success">
            <div class="success">
                <h4 [innerHTML]="'forgotPassword.titleSuccess' | translate"></h4>
                <div [innerHTML]="('forgotPassword.messageSuccess' | translate).replace('username', username2)"></div>
            </div>
            <div class="form-group button-wrapper">
                <a href="javascript:;" class="primary button" (click)="cancel()"
                    ><span [innerHTML]="'forgotPassword.ok' | translate"></span
                ></a>
            </div>
        </div>
    </ng-container>
</div>
